import type { FetchEligibleEmailsResponse } from './types';

const THIRD_PARTY_WITHIN_ONE_P_ELIGIBILITY_PATH =
	'/gateway/api/growth/3p-within-1p/email-eligibility';

export const fetchEligibleEmails = async (
	emails: string[],
	productId: 'jira' | 'jira-servicedesk' | 'confluence',
): Promise<FetchEligibleEmailsResponse> => {
	const response = await fetch(THIRD_PARTY_WITHIN_ONE_P_ELIGIBILITY_PATH, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ emails, productId }),
	});
	if (!response.ok) {
		throw new Error(`HTTP error ${response.status}`);
	}
	return (await response.json()) ?? {};
};
